module.exports = __webpack_public_path__ + "static/media/zheka2.3ba020e9.png";